// Workout plan data for UMUT ŞAHİN — GoodPT (Goodlife FCS V-Shape Program)
export const TRAINEE = {
  name: "UMUT ŞAHİN",
  program: "V-Shape & Postür Düzeltme Programı",
  phase: "İlk Faz · 4 Hafta",
  motto: "Duruşunu düzelt, sırtını güçlendir, V-Shape'ini yarat!",
};

export const PROGRAM_INFO = [
  { label: "Süre", value: "4 Hafta", sub: "İlk Faz" },
  { label: "Frekans", value: "5 Gün", sub: "Haftada" },
  { label: "Set × Tekrar", value: "3 × 12", sub: "Standart" },
  { label: "Dinlenme", value: "60-90 sn", sub: "Setler arası" },
  { label: "Kardiyo", value: "20-30 dk", sub: "Eğimli yürüyüş" },
];

export const POSTURE_PROBLEMS = [
  { problem: "Baş öne taşınmış (Forward Head Posture)", target: "Baş nötr pozisyonda hizalanacak" },
  { problem: "Omuzlar öne dönmüş (Rounded Shoulders)", target: "Omuzlar geriye açılacak" },
  { problem: "Torasik kifoz artmış (Kambur duruş)", target: "Göğüs kafesi açılacak" },
  { problem: "Orta ve alt trapez zayıf", target: "Üst sırt güçlenecek" },
  { problem: "Core stabilitesi düşük", target: "Core güçlenecek" },
  { problem: "Bel çevresinde yağlanma", target: "V-shape görünüm hedeflenecek" },
];

export const PROGRAM_GOALS = [
  "V-Shape (geniş sırt & omuz) görünümü",
  "Postürü düzeltmek ve dik duruş sağlamak",
  "Bel çevresini inceltmek",
  "Kas kütlesi artırmak",
  "Yağ oranını düşürmek",
  "Güçlü ve sağlıklı bir vücut",
];

export const WARMUP = [
  { name: "Jumping Jack", reps: "2 × 30 sn", video: "c4DAnQ6DtF8" },
  { name: "Arm Circle", reps: "2 × 15 tekrar (öne + geriye)", video: "140RTNMciH8" },
  { name: "Bodyweight Squat", reps: "2 × 15 tekrar", video: "aclHkVaku9U" },
];

export const POSTURE_DRILLS = [
  { name: "Chin Tuck", reps: "2 × 15 tekrar", video: "7rnlAVhAK-8" },
  { name: "Wall Slide", reps: "2 × 15 tekrar", video: "tWDGEyMWv10" },
  { name: "Band Pull Apart", reps: "2 × 20 tekrar", video: "I2RyubW9UsM" },
];

export const WEEKLY_PROGRAM = [
  {
    day: "Pazartesi",
    focus: "Sırt & Arka Omuz",
    color: "from-emerald-500/30 to-emerald-500/5",
    exercises: [
      { name: "Lat Pulldown", reps: "3 × 12", video: "CAwf7n6Luuc" },
      { name: "Chest Supported Row", reps: "3 × 12", video: "_b6ch2nIchk" },
      { name: "Face Pull", reps: "3 × 12", video: "rep-qVOkqgk" },
      { name: "Rear Delt Fly", reps: "3 × 12", video: "ttvfGg9d76c" },
      { name: "Plank", reps: "3 × 12 (30-45 sn)", video: "pSHjTRCQxIw" },
    ],
  },
  {
    day: "Salı",
    focus: "Göğüs & Omuz",
    color: "from-blue-500/30 to-blue-500/5",
    exercises: [
      { name: "Incline Dumbbell Press", reps: "3 × 12", video: "8iPEnn-ltC8" },
      { name: "Machine Chest Press", reps: "3 × 12", video: "xUm0BiZCWlQ" },
      { name: "Cable Lateral Raise", reps: "3 × 12", video: "Z5FA9aq3L6A" },
      { name: "Wall Slide", reps: "3 × 12", video: "tWDGEyMWv10" },
      { name: "Dead Bug", reps: "3 × 12", video: "4XLEnwUr1d8" },
    ],
  },
  {
    day: "Çarşamba",
    focus: "Postür, Core & Kardiyo",
    color: "from-amber-500/30 to-amber-500/5",
    badge: "KARDİYO GÜNÜ",
    exercises: [
      { name: "Bird Dog", reps: "3 × 12", video: "wiFNA3sqjCA" },
      { name: "Pallof Press", reps: "3 × 12", video: "AH_QZLm_0-s" },
      { name: "Side Plank", reps: "3 × 12 (30 sn)", video: "K2VljzCC16g" },
    ],
    cardio: "20-30 dakika eğimli yürüyüş",
  },
  {
    day: "Perşembe",
    focus: "V-Shape Günü",
    color: "from-cyan-500/30 to-cyan-500/5",
    badge: "EN ÖNEMLİ GÜN",
    exercises: [
      { name: "Wide Grip Lat Pulldown", reps: "3 × 12", video: "JGeRYIZdojU" },
      { name: "Seated Cable Row", reps: "3 × 12", video: "GZbfZ033f74" },
      { name: "Cable Lateral Raise", reps: "3 × 12", video: "Z5FA9aq3L6A" },
      { name: "Straight Arm Pulldown", reps: "3 × 12", video: "kiuVA0gs3EI" },
      { name: "Plank", reps: "3 × 12 (30-45 sn)", video: "pSHjTRCQxIw" },
    ],
  },
  {
    day: "Cuma",
    focus: "Üst Göğüs & Kollar",
    color: "from-purple-500/30 to-purple-500/5",
    exercises: [
      { name: "Incline Machine Press", reps: "3 × 12", video: "lJ2o89kcnxY" },
      { name: "Cable Fly", reps: "3 × 12", video: "Iwe6AmxVf7o" },
      { name: "Seated Overhead Press", reps: "3 × 12", video: "2yjwXTZQDDI" },
      { name: "EZ Bar Curl", reps: "3 × 12", video: "kwG2ipFRgfo" },
      { name: "Rope Pushdown", reps: "3 × 12", video: "2-LAMcpzODU" },
    ],
  },
];

export const COOLDOWN = [
  { name: "Doorway Chest Stretch", reps: "30 sn × 2", video: "M850sCj9LHQ" },
  { name: "Upper Trapezius Stretch", reps: "30 sn × 2", video: "yho44869qPw" },
  { name: "Levator Scapula Stretch", reps: "30 sn × 2", video: "0_RO8NbdKBc" },
];

export const TIPS = [
  { icon: "🍌", title: "Doğru form her şeyden önemlidir", body: "Ağırlığı arttırmadan önce tekniği oturt. Yanlış form sakatlık demek." },
  { icon: "🔥", title: "Beslenmene dikkat et", body: "Şekillenmen hızlansın diye protein, kompleks karbonhidrat ve yeterli su." },
  { icon: "🛏️", title: "Yeterli uyku ve dinlenme", body: "Kas büyümesi uyku sırasında olur — 7-9 saat hedefle." },
  { icon: "📈", title: "İlerlemeni takip et", body: "Sabırlı ve istikrarlı ol. Haftalık ölçüm + fotoğraf çek." },
  { icon: "✅", title: "Disiplin her şeyin anahtarı", body: "Program ancak uygulanırsa işe yarar. Bu program senin için tasarlandı, Umut!" },
];
